

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { BreadcrumbViewModel } from '../api/breadcrumb';

@Component({})
export default class Breadcrumb extends Vue {
  @Prop()
  private data!: BreadcrumbViewModel[];

}
